"use client";

import { useState } from "react";
import Image from "next/image";
import { cn } from "@/lib/utils";

interface ProductGalleryProps {
    images: string[];
}

export function ProductGallery({ images }: ProductGalleryProps) {
    const [mainImage, setMainImage] = useState(images[0]);

    if (!images || images.length === 0) return null;

    return (
        <div className="flex flex-col gap-4">
            {/* Main Image */}
            <div className="relative aspect-square w-full rounded-2xl overflow-hidden bg-white border border-gray-100">
                <Image
                    src={mainImage}
                    alt="Product Main"
                    fill
                    className="object-contain p-8 hover:scale-105 transition-transform duration-500"
                    priority
                />
            </div>

            {/* Thumbs */}
            {images.length > 1 && (
                <div className="flex gap-4 overflow-x-auto pb-2">
                    {images.map((img, idx) => (
                        <button
                            key={idx}
                            onClick={() => setMainImage(img)}
                            className={cn(
                                "relative w-20 h-20 rounded-xl overflow-hidden border-2 flex-shrink-0 bg-white",
                                mainImage === img ? "border-blue-600" : "border-gray-100 hover:border-blue-300"
                            )}
                        >
                            <Image
                                src={img}
                                alt={`Thumb ${idx}`}
                                fill
                                className="object-contain p-2"
                            />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
